import { combineReducers } from 'redux';
import { createHttpReducer, createListReducer } from "./http";
import { loadLocalState } from '../actions/http';

let userInitialState = {
    fetching: false,
    error: false,
    data: {},
    logout_fetching: false,
    logout_error: false,
    update_profile_fetching: false,
    update_profile_error: false,
};

const user = loadLocalState();

if(user){
    userInitialState = {...userInitialState, data: user}    
}

//login reducer
export const loginReducer = (state = userInitialState , action) => {
    switch(action.type){
        case "LOGIN_FETCHING":
            return {...state, fetching: true, data: {}, error: false}
        case "LOGIN_FULFILLED": 
            return {...state, fetching: false, data: action.payload , error: false}
        case "LOGIN_REJECTED":
            return {...state, fetching: false, data: {}, error : action.payload }
        case "UPDATE_PROFILE_FETCHING":
            return {...state, update_profile_fetching: true, update_profile_error: false, update_profile_success: false}
        case "UPDATE_PROFILE_FULFILLED": 
            return {...state, update_profile_fetching: false, data: {...state.data ,...action.payload} , update_profile_error: false, update_profile_success: true}
        case "UPDATE_PROFILE_REJECTED":
            return {...state, update_profile_fetching: false, update_profile_error : action.payload, update_profile_success: false }
        case "LOGOUT_FETCHING":
            return {...state, logout_fetching: true, logout_error: false, logout: false}
        case "LOGOUT_FULFILLED":
            return {...state, logout_fetching: false, logout_error: false, data: {}, logout: true}
        case "LOGOUT_REJECTED":
            return {...state, logout_fetching: false, logout_error: action.payload, logout: false}
        default:
            return state
    }
}

const location = createHttpReducer('LOC');

const estimate = createHttpReducer('ESTIMATE_PRICE');

const initiallocstate = {
    pickup: null, 
    drop: null, 
    pickupAddress: '',
    dropAddress: '',
    pickupChanged: false, 
    dropChanged: false, 
    drag:false
};

const bookingLoc = (state = initiallocstate, action) => {
    switch(action.type){
        case "PICKUP_LOC": 
            return {...state, pickup: action.pos, pickupAddress: action.address, pickupChanged: action.pickupChanged,  dropChanged: false, drag: action.drag}
        case "DROP_LOC": 
            return {...state, drop: action.pos, dropAddress: action.address, dropChanged: action.dropChanged, pickupChanged: false, drag: action.drag}
        case "CLEAR_PICKUP":
            return {...state, pickup: null, pickupAddress: '', pickupChanged: false}
        case "CLEAR_DROP":
            return {...state, drop: null, dropAddress: '', dropChanged: false}
        case "CLEAR_LOC": 
            return {...state, ...initiallocstate}
        default: 
            return state
    }
}

//modal reducer
export const modalReducer = (state = { open: false }, action) => {
    let { type, modalName, modalProps} = action;
    switch(type) {
        case 'OPEN_MODAL': 
            return {...state,open: true, modalName, modalProps}
        case 'CLOSE_MODAL': 
            return {...state,open: false}
        default:
            return state
    }
}

//toast reducer
export const toast = (state=[], action) => {
    switch (action.type) {
        case "ADD_TOAST":
            return [...state, action.payload]
        case "REMOVE_TOAST":
            return state.filter(x => x.id !== action.id)
        case "CLEAR_TOAST":
            return []
        default:
            return state;
    }
}
//ends here

//images preview reducer
export const imagePreview = (state = [], action) => {
    switch(action.type){
        case "ADD_IMAGE_PREIVEW": 
            return [...state, ...action.images]
        case "REMOVE_IMAGE_PREIVEW":
            return state.filter(x => x.id !== action.id)
        case "CLEAR_IMAGE_PREIVEW":
            return []
        default:
            return state
    }
}

const createOrder = createHttpReducer("CREATE_ORDER");

const insDon = createHttpReducer("INSDON");

const insAmt = (state = {insurance: 0, donation: 0}, action) => {
    switch(action.type){
        case "UPDATE_INS_AMT":
            return {...state, ...action.payload}
        default:
            return state
    }
}

//show hide order direction 
const orderdirection = (state = { pickup: null, drop: null }, action) => {
    switch(action.type){
        case 'SHOW_ORDER_DIRECTION':
            return {...state, ...action.endpoints}
        case 'HIDE_ORDER_DIRECTION':
            return {...state, pickup: null, drop: null}
        default:
            return state
    }
}

// export const orderlist_upcoming = createListReducer("ORDERLIST_UPCOMING");

export const orderlist_completed = createListReducer("ORDERLIST_COMPLETED");

const offers = createListReducer("OFFERS");

let orderintial = {fetching: false, data: [], error: false, nextFetching: false, nextError: false, next: null};

export const orderlist_upcoming = (state = orderintial, action) => {
    switch(action.type){
        case 'ORDERLIST_UPCOMING_FETCHING':
            return {...state, ...orderintial, fetching: true}
        case 'ORDERLIST_UPCOMING_FULFILLED':
            return { ...state,
                fetching: false,
                data: action.payload.results,
                next: action.payload.next
            }
        case 'ORDERLIST_UPCOMING_REJECTED':
            return {...state, fetching: false, error: action.payload}
        case 'ORDERLIST_UPCOMING_NEXT_FETCHING':
            return {...state, nextFetching: true, nextError: false}
        case 'ORDERLIST_UPCOMING_NEXT_FULFILLED':
            return {...state, 
                nextFetching: false,
                next: action.payload.next,
                data: [...state.data, ...action.payload.results]
            }
        case 'ORDERLIST_UPCOMING_NEXT_REJECTED':
            return {...state, nextFetching: false, nextError: true}
        case 'ORDERLIST_UPCOMING_UPDATE_PAID':
            return {...state, 
                data: state.data.map(x => {
                    if(x.id === action.id){
                        return ({
                            ...x, pay_status: action.paid
                        })
                    }
                    return x
                })
            }
        case 'ORDERLIST_UPCOMING_CLEAR':
            return {...state, ...orderintial}
        default: 
            return state;
    }
}

const order_online_pay = createHttpReducer("ORDER_PAY_ONLINE");

export const master = createHttpReducer("GET_MASTER");

export const masterValue = createHttpReducer("GET_MASTERVALUE");

export const rateCard = createHttpReducer("GET_RATE_CARD");

const team = createHttpReducer("OUR_TEAM");

const coupon = (state = {}, action) => {
    switch(action.type){
        case 'APPLY_COUPON':
            return {...state, ...action.payload}
        case 'CLEAR_COUPON':
            return {}
        default:
            return state
    }
}

export default combineReducers({
    loginReducer,
    modalReducer,
    imagePreview,
    location,
    bookingLoc,
    createOrder,
    orderlist_upcoming,
    orderlist_completed,
    offers,
    estimate,
    orderdirection,
    toast,
    order_online_pay,
    master,
    masterValue,
    rateCard,
    team,
    coupon,
    insDon,
    insAmt
})